<app-header></app-header>

  <div class="container">
    <div class="box">

      <div class="content" *ngIf="exibirConteudo == 1">
        <h2>Esse link não está mais válido =( </h2>
        <img src="../../assets/images/link_invalido.svg" alt="Pagamento Confirmado">
        <h4>Entre em contato com seu corretor e solicite
          o envio de um novo link de pagamento</h4>         
      </div>

      <div class="content" *ngIf="exibirConteudo == 2">
        <h2>Pagamento Realizado com sucesso!</h2>
        <img src="../../assets/images/sucesso_pagamento.svg" alt="Pagamento Realizado">

       <app-comprovante-pagamento></app-comprovante-pagamento> 
        
      </div>

      <div class="content" *ngIf="exibirConteudo == 3">
        <h2>Esse pagamento já foi realizado =)</h2>
        <img src="../../assets/images/pgto_confirmado.svg" alt="Pagamento Confirmado">
      </div>

    </div>

  </div>

<app-footer></app-footer>


